import { useEffect } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

function getDeviceType() {
  if (typeof window === "undefined") return "unknown";
  const ua = navigator.userAgent || "";
  if (/bot|crawler|spider|crawling/i.test(ua)) return "unknown";
  const isMobile = /Mobi|Android|iPhone/i.test(ua);
  const isTablet = /Tablet|iPad/i.test(ua) || (isMobile && window.innerWidth >= 768);
  if (isTablet) return "tablet";
  if (isMobile) return "mobile";
  return "desktop";
}

function getSessionId() {
  try {
    let id = sessionStorage.getItem("arvo_sid");
    if (!id) {
      id =
        (crypto?.randomUUID && crypto.randomUUID()) ||
        Math.random().toString(36).slice(2) + Date.now().toString(36);
      sessionStorage.setItem("arvo_sid", id);
    }
    return id;
  } catch {
    return Math.random().toString(36).slice(2);
  }
}

export default function useVisitTracker(path = "/") {
  useEffect(() => {
    // Only fire once per session per path to avoid inflating refresh counts
    const key = `arvo_v_${path}`;
    try {
      if (sessionStorage.getItem(key)) return;
    } catch {
      /* sessionStorage not available — still fire once per page load */
    }

    const payload = {
      session_id: getSessionId(),
      path,
      referrer: typeof document !== "undefined" ? document.referrer || null : null,
      device: getDeviceType(),
    };

    axios
      .post(`${API}/visits`, payload)
      .then(() => {
        try {
          sessionStorage.setItem(key, "1");
        } catch {
          /* ignore */
        }
      })
      .catch(() => {
        /* analytics failures are silent */
      });
  }, [path]);
}
